import { useEffect } from 'react';

export interface ThirdPartyScriptProps {
	id?: string;
	src?: string;
	functionScript?: string;
	place?: 'head' | 'body';
	async?: boolean;
	defer?: boolean;
	onLoad?: () => void;
	onError?: () => void;
}

export const ThirdPartyScript: React.FC<ThirdPartyScriptProps> = ({
	id,
	src,
	functionScript,
	place = 'body',
	async = true,
	defer = false,
	onLoad,
	onError,
}) => {
	useEffect(() => {
		const element = document.createElement('script');
		element.async = async;
		element.defer = defer;
		if (id) element.id = id;
		if (src) element.src = src;
		if (onLoad) element.onload = onLoad;
		if (onError) element.onerror = onError;
		if (functionScript) element.append(functionScript);
		const target = place === 'head' ? document.head : document.body;
		target.appendChild(element);
		return () => {
			target.removeChild(element);
		};
	}, [src, place, async, defer, onLoad, onError, id, functionScript]);

	return null;
};
